import React from 'react';
import routerProvider from '@pankod/refine-react-router-v6';
import { logoStyle } from './styles';

const { Link } = routerProvider;

export const Title: React.FC = () => (
  <Link to="/">
    <img src={process.env.PUBLIC_URL + '/logo.png'} alt="BF Stride Group Logo" style={logoStyle} />
  </Link>
);
